import styled from 'styled-components';
import Link from '../../Atoms/Link/Link';
import zIndex from '../../../theme/shared/zIndex';
import { container } from '../../../theme/shared/size';
var HeaderWrapper = styled.header.attrs(function () {
  return {
    role: 'banner'
  };
}).withConfig({
  displayName: "Headerstyle__HeaderWrapper",
  componentId: "sc-11ghppe-0"
})(["position:relative;background-color:", ";padding:0;height:75px;@media ", "{height:auto;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.color('white');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoint('nav');
});
var InnerWrapper = styled.div.withConfig({
  displayName: "Headerstyle__InnerWrapper",
  componentId: "sc-11ghppe-1"
})(["display:flex;align-items:center;height:100%;padding:0 12px;cursor:pointer;max-width:", ";@media ", "{margin:0 auto;}"], container.large, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoint('nav');
});
/**
 * Brand wrapper
 */

var Brand = styled(Link).withConfig({
  displayName: "Headerstyle__Brand",
  componentId: "sc-11ghppe-2"
})(["", ";color:transparent;margin-right:auto;border:0;:hover{border:0;}"], zIndex('high'));
/**
 * Meta icons
 */

var MetaIcons = styled.div.withConfig({
  displayName: "Headerstyle__MetaIcons",
  componentId: "sc-11ghppe-3"
})(["width:auto;display:flex;align-items:center;> div{height:35px;width:auto;display:inline-block;> a{height:inherit;width:inherit;margin-left:", ";img{padding:5px;height:inherit;width:inherit;}}}@media ", "{position:relative;display:flex;align-items:center;background-color:", ";margin-right:0px;right:0px;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize('xxs');
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoint('nav');
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.color('white');
});
export { Brand, HeaderWrapper, InnerWrapper, MetaIcons };